import styled from 'styled-components'

export const ChartsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  align-items: space-between;
`

interface ChartSelectorProps {
  collumns?: number
}

export const SelectorsGrid = styled.div<ChartSelectorProps>`
  display: grid;
  grid-template-columns: repeat(${({ collumns }) => collumns || 3}, 1fr);
  grid-row-gap: ${({ collumns }) => (collumns === 4 ? '4px' : '8px')};
  grid-column-gap: ${({ collumns }) => (collumns === 4 ? '8px' : '12px')};
  justify-content: center;

  /* @media (max-height: 800px) {
    grid-row-gap: 5px;
    grid-column-gap: 16px;
  } */
`

export const Subtitle = styled.h2`
  ${({ theme }) => theme.fonts.infoMD}
  color: ${({ theme }) => theme.colors.neutralL5};
  width: 100%;
`

interface ToolContainerProps {
  gap: number
}

export const ToolContainer = styled.div<ToolContainerProps>`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin: 10px 0;
  gap: ${({ gap }) => gap}px;
`
